import {
  FilterType,
  buildProjectEmployeesDataTableFilter,
  useProjectEmployeesDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import AssignedTag from 'modules/project_management/components/labelTags/AssignedTag'

const options = () => {
  return [
    {
      label: i18n.t('project_management.table.project_employees.assignation_tags.assigned'),
      value: true,
      component: <AssignedTag employeeStatus />,
    },
    {
      label: i18n.t('project_management.table.project_employees.assignation_tags.not_assigned'),
      value: false,
      component: <AssignedTag employeeStatus={false} />,
    },
  ]
}

export const AssignedFilter = (source: ReturnType<typeof useProjectEmployeesDataTable>) =>
  buildProjectEmployeesDataTableFilter(source, {
    type: FilterType.Boolean,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
      },
    ],
    identifier: 'assignFilter',
    path: 'assigned',
    title: i18n.t('project_management.table.project_employees.headers.status'),
    default: true,
  })
